import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  height: 550px;
  gap: 10px;
  background: ${({ theme }) => theme.colors.black2};
  border: 1px solid ${({ theme }) => theme.colors.black9};
`;
